var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h6 text-sm-h5 text-md-h4 mb-4 primary--text"},[_vm._v("I forgot my password")]),_c('div',[_c('p',[_vm._v("Click on the \"Forgot password?\" link on the login page")]),_c('v-btn',{staticClass:"text-decoration-none",attrs:{"to":"/login","color":"primary"}},[_vm._v("go to login")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }